/** @jsx jsx */

/** @jsxFrag React.Fragment */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { compose } from 'recompose';

import { Grid, PageGridContainer } from '@coursera/cds-core';

import { MetaNavigation, isMetaNavEnabled } from 'bundles/ent-website/components/MetaNavigation';
import HeaderLogo from 'bundles/page-header/components/HeaderLogo';
import HeaderRightNav from 'bundles/page-header/components/HeaderRightNavV2';
import BrowseContentWrapper from 'bundles/page-header/components/desktop/BrowseContentWrapper';
import withDesktopBanners from 'bundles/page-header/hoc/withDesktopBanners';
import useUserAgent from 'bundles/page/hooks/useUserAgent';

type Props = {
  isFrontPage?: boolean;
  isStandaloneAuth?: boolean;
  isSearchPage?: boolean;
  logoWrapper?: string;
  hideRightNav?: boolean;
  hideSearch?: boolean;
};

export const styles = {
  unifiedLogo: css`
    .rc-HeaderLogo {
      margin-right: 0;
    }
  `,
  pageHeaderContainer: css`
    display: flex;
    align-items: center;
  `,
  headerRightNavWrapper: css`
    margin-left: auto;
    min-width: 250px;
    float: right;
  `,
  searchBar: css`
    max-width: 600px !important;
    flex-shrink: 0;
    flex: 1;
  `,
  navbarContainer: css`
    .bt3-nav::before,
    .bt3-navbar::before,
    .bt3-nav::after,
    .bt3-navbar::after {
      content: ' ';
      display: table;
    }

    .bt3-nav::after,
    .bt3-navbar::after {
      clear: both;
    }

    .bt3-nav {
      margin-bottom: 0;
      padding-left: 0;
      list-style: none;
    }

    .bt3-nav > li {
      position: relative;
      display: block;
    }

    .bt3-nav > li > a {
      position: relative;
      display: block;
      padding: 10px 15px;
    }

    .bt3-nav > li > a:hover,
    .bt3-nav > li > a:focus {
      text-decoration: none;
      background-color: #eee;
    }

    .bt3-nav > li.bt3-disabled > a {
      color: #999;
    }

    .bt3-nav > li.bt3-disabled > a:hover,
    .bt3-nav > li.bt3-disabled > a:focus {
      color: #999;
      text-decoration: none;
      background-color: transparent;
      cursor: not-allowed;
    }

    .bt3-navbar {
      min-height: 50px;
    }
  `,
};

export const LoggedOutDesktopHeader = ({ logoWrapper, hideSearch, hideRightNav, isStandaloneAuth }: Props) => {
  const userAgent = useUserAgent();
  const metaNavEnabled = isMetaNavEnabled();

  const headerRightNavProps = {
    hideEnterprise: userAgent?.isOculusQuest,
    isStandaloneAuth,
  };

  const content = (
    <div
      css={styles.navbarContainer}
      data-testid="logged-out-desktop-header"
      className="rc-PageHeader rc-PageHeader--MetaNav rc-PageHeader--PageNavigation"
    >
      <div className="bt3-navbar c-ph-nav full-width">
        <div className="c-container" css={styles.pageHeaderContainer}>
          <div css={styles.unifiedLogo}>
            <HeaderLogo hexColorCode="#2A73CC" logoWrapper={logoWrapper} />
          </div>
          {!hideSearch && (
            <div className="c-ph-search-catalog nav-item horizontal-box browse-search" css={styles.searchBar}>
              <BrowseContentWrapper />
            </div>
          )}

          {!hideRightNav && (
            <div className="header-right-nav-wrapper" css={styles.headerRightNavWrapper} data-testid="header-right-nav">
              <HeaderRightNav {...headerRightNavProps} />
            </div>
          )}
        </div>
      </div>
    </div>
  );

  return (
    <>
      {metaNavEnabled && <MetaNavigation />}
      <PageGridContainer>
        <Grid xs={12} item>
          {content}
        </Grid>
      </PageGridContainer>
    </>
  );
};

export default compose<Props, Props>(withDesktopBanners)(LoggedOutDesktopHeader);
